<template>
  <div class="trading">
    <div class="page-title">TRADING CENTER</div>
    <div class="down">
      <div class="search_bar">
        <div class="search_item">空间模型</div>
        <div class="search_item">人物模型</div>
        <div class="search_item">动态模型</div>
        <div class="search_item">道具市场</div>
      </div>
      <div class="input_dom">
        <input type="text" class="ipt" />
        <img class="search-icon" src="@/assets/images/search.png" alt="" />
      </div>
    </div>
    <div class="top">
      <div class="title">热门推荐</div>
      <div class="swiper-box-1">
        <swiper
          :modules="modules"
          :slides-per-view="3"
          :space-between="10"
          :navigation="navigation"
          :pagination="{ clickable: true, el: '.custom-pagination1' }"
        >
          <swiper-slide v-for="(item, index) in numSlides" :key="index">
            <div class="slider-item">
              <div class="content">
                <img
                  class="img"
                  src="https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png"
                />
                <div class="enter" @click="openDetail">ENTER</div>
              </div>

              <div class="detail">
                <div class="left">
                  <div class="avatr"></div>
                  <div class="avatr_1">作者：</div>
                  <div class="avatr_2">用户123@Aa</div>
                </div>
                <div class="right">￥100</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="custom-pagination1">
          <div
            class="swiper-pagination-bullet1"
            v-for="(item, index) in numSlides"
            :key="index"
            :style="paginationBulletWidth"
          ></div>
        </div>
        <!-- 自定义分页器容器 -->
      </div>
    </div>
    <div class="middle">
      <div class="search">
        <div class="left">免费推荐</div>
        <div class="right">付费推荐</div>
      </div>
      <div class="content">
        <div class="item" v-for="(i, index) in 9" :key="index">
          <div class="item_content">
            <img
              class="img"
              src="https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png"
            />
            <div class="enter" @click="openDetail">ENTER</div>
          </div>

          <div class="detail">
            <div class="left">
              <div class="avatr"></div>
              <div class="avatr_1">作者：</div>
              <div class="avatr_2">用户123@Aa</div>
            </div>
            <div class="right">{{ "00" + (index + 1) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="DetailStatus" class="mark">
      <Detail :close="close" />
    </div> -->
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, computed } from "vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination"; // 导入 Pagination 样式
import "swiper/css";
// import Detail from "./components/detail.vue";

// const highlightedIndex = ref(0);
const numSlides = ref(4);
const DetailStatus = ref(false);
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});

const modules = [Navigation, Pagination];
// const list = ref([
//   {
//     id: 1,
//     url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//     hoverUrl:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/shadow.png",
//     base_url:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//   },
//   {
//     id: 2,
//     url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//     hoverUrl:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/shadow.png",
//     base_url:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//   },
//   {
//     id: 3,
//     url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//     hoverUrl:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/shadow.png",
//     base_url:
//       "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/moon-cat.png",
//   },
// ]);

// const handleMouseOver = (item) => {
//   item.url = item.hoverUrl;
// };

// const handleMouseLeave = (item) => {
//   item.url = item.base_url;
// };
// const handleMouseOverImg = (index) => {
//   highlightedIndex.value = index;
// };
const paginationBulletWidth = computed(() => {
  return `${100 / (numSlides.value - 2)}%`;
});

const openDetail = () => {
  DetailStatus.value = true;
};
// const close = () => {
//   DetailStatus.value = false;
// };
</script>
<style lang="scss" scoped>
.trading {
  background-color: var(--ux-card-bg);
  padding: 86px 240px 0 240px;
  .page-title {
    margin-top: 84px;
    font-weight: bold;
    font-size: 80px;
    color: var(--ux-text-primary);
    line-height: 93.996px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .down {
    margin-bottom: 42px;
    .search_bar {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30.996px 0 44.002px 0;
      .search_item {
        width: 159px;
        height: 46px;
        background: var(--ux-glass-bg-subtle);
        border-radius: 10px 10px 10px 10px;
        text-align: center;
        line-height: 46px;
        font-size: 16px;
        margin: 0 14px;
        cursor: pointer;
        font-weight: 400;
        font-size: 20px;
        color: var(--ux-text-primary);
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .input_dom {
      position: relative;
      width: 728px;
      margin: 0 auto;

      .ipt {
        width: 728px;
        height: 51.996px;
        background: var(--ux-surface-muted);
        border-radius: 10px 10px 10px 10px;
        opacity: 0.5;
        border: none;
      }
      .search-icon {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
      }
    }
  }
  .top {
    .title {
      font-weight: 400;
      font-size: 23.996px;
      color: var(--ux-text-primary);
      line-height: 28px;
      font-style: normal;
      text-transform: none;
    }
    .swiper-box-1 {
      margin-top: 28px;
      .slider-item {
        .content {
          position: relative;
          img {
            width: 471px;
            height: 287px;
          }
          .enter {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 109.998px;
            height: 42px;
            font-weight: bold;
            font-size: 16.002px;
            background: var(--ux-surface-solid);
            border-radius: 60.004px 60.004px 60.004px 60.004px;
            color: #fff;
            opacity: 0.36;
            line-height: 42px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
          }
        }

        .detail {
          height: 70px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          .left {
            display: flex;
            align-items: center;
            .avatr {
              width: 44px;
              height: 44px;
              background: var(--ux-surface-muted);
              border-radius: 50%;
              margin-right: 14px;
            }
            .avatr_1 {
              font-weight: 400;
              font-size: 16px;
              color: var(--ux-text-primary);
              line-height: 18.998px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            .avatr_2 {
              font-weight: 400;
              font-size: 16px;
              color: var(--ux-text-primary);
              line-height: 18.998px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .right {
            font-weight: bold;
            font-size: 20.006px;
            color: var(--ux-text-primary);
            line-height: 23.002px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-right: 7px;
          }
        }
      }

      .custom-pagination1 {
        padding: 22px 0;
        text-align: center;

        ::v-deep .swiper-pagination-bullet {
          height: 8px;
          width: v-bind(paginationBulletWidth);
          background: var(--ux-surface-muted);
          opacity: 0.5;
          border-radius: 0;
          margin: 0;
          border-radius: 5px;
        }
        ::v-deep .swiper-pagination-bullet-active {
          background-color: var(--ux-accent, #00d4ff);
        }
      }
    }
  }
  .middle {
    padding: 28px 0 0 0;
    .search {
      display: flex;
      margin-bottom: 56px;
      .left {
        font-weight: 400;
        font-size: 24px;
        color: var(--ux-text-primary);
        line-height: 28px;
        font-style: normal;
        text-transform: none;
        margin-right: 28px;
      }
      .right {
        font-weight: 400;
        font-size: 23.996px;
        color: #828282;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .content {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr; /* 将容器分为三列，每列宽度相等 */
      gap: 10px; /* 设置列之间的间隔 */

      .item {
        width: 471px;
        height: 287px;
        margin-bottom: 98px;
        .item_content {
          width: 100%;
          height: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .enter {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 109.998px;
            height: 42px;
            font-weight: bold;
            font-size: 16.002px;
            background: var(--ux-surface-solid);
            border-radius: 60.004px 60.004px 60.004px 60.004px;
            color: #fff;
            opacity: 0.36;
            line-height: 42px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
          }
        }

        .detail {
          height: 70px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          .left {
            display: flex;
            align-items: center;
            .avatr {
              width: 44.002px;
              height: 44.002px;
              background: var(--ux-surface-muted);
              border-radius: 50%;
              margin-right: 14px;
            }
            .avatr_1 {
              font-weight: 400;
              font-size: 16.002px;
              color: var(--ux-text-primary);
              line-height: 18.998px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            .avatr_2 {
              font-weight: 400;
              font-size: 16.002px;
              color: var(--ux-text-primary);
              line-height: 18.998px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .right {
            font-weight: bold;
            font-size: 20.006px;
            color: var(--ux-text-primary);
            line-height: 23.002px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-right: 7px;
          }
        }
      }
    }
  }

  .mark {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
    z-index: 999; /* 确保遮罩在其他内容之上 */
  }
}
</style>
